import React from "react";
import AWS_IMAGE from "../../assets/images/aws.svg";
import SLS_IMAGE from "../../assets/images/sls.svg";
import DEVOPS_IMAGE from "../../assets/images/devops.svg";
import MICROSERVICES_IMAGE from "../../assets/images/microservices.svg";
import FINOPS_IMAGE from "../../assets/images/finops.png";
import COMPLIANCE_IMAGE from "../../assets/images/compliance.svg";
import CLOUD_TRAINING_IMAGE from "../../assets/images/cloud-training.png";
import "./Offerings.css";

const Services = (props) => {
    // Data for the new services
    const servicesData = [
        {
            id: 1,
            image: DEVOPS_IMAGE,
            title: "On-Demand Consulting",
            description: "Flexible consulting services tailored to your immediate cloud infrastructure needs.",
            type: "onDemand"
        },
        {
            id: 2,
            image: FINOPS_IMAGE,
            title: "Project Based Consulting",
            description: "Project-specific consulting services for AWS cloud deployments and management.",
            type: "onDemand"
        },
        {
            id: 3,
            image: COMPLIANCE_IMAGE,
            title: "Compliance Readiness",
            description: "Be prepared for SOC2 & HIPAA Compliance with our team of experts",
            type: "onDemand"
        },
        {
            id: 4,
            image: CLOUD_TRAINING_IMAGE,
            title: "Training",
            description: "Comprehensive training programs for AWS cloud services and best practices.",
            type: "onDemand"
        },
        {
            id: 5,
            image: AWS_IMAGE,
            title: "Starter Package",
            price: 3000,
            points: [
                "For Small Businesses",
                "10 billable hours included monthly",
                "Monitoring",
                "Cost Optimization",
                "Email Support"
            ],
            type : "monthly"

        },
        {
            id: 6,
            image: AWS_IMAGE,
            title: "Light Package",
            points: [
                "For Startups",
                "15 billable hours included monthly",
                "Email & Slack Support",
                "Everything in Starter Package",
            ],
            price: 5000,
            type : "monthly"
        },
        {
            id: 7,
            image: AWS_IMAGE,
            title: "Professional Package",
            points: [
                "For Startups & Medium-sized Businesses",
                "25 billable hours included monthly",
                "7/24 Monitoring",
                "Email, Slack Support",
                "Everything in Light Package"
            ],
            price: 8000,
            type : "monthly"
        },
        {
            id: 8,
            image: AWS_IMAGE,
            title: "Enterprise Package",
            points: [
                "For More Demanding Businesses & Enterprises",
                "35 billable hours included monthly",
                "Email, Slack, Phone Support",
                "Service Level Agreement (SLA)",
                "Everything in Professional Package",
            ],
            price: 12000,
            type : "monthly"
        }
    ];



    // Map through each data array to create service items
    const monthlyServiceItems = servicesData.filter(x=>x.type==="monthly").map(data => <ServiceItem {...data} />);
    const serviceItems = servicesData.filter(x=>x.type==="onDemand").map(data => <ServiceItem {...data} />);

    return (
        <div id="offering">
            {servicesSection(
                "services",
                "Consulting & Training Services",
                "Discover our custom consulting solutions and training services for your cloud needs.",
                serviceItems
            )}

            {servicesSection(
                "monthly-services",
                "Monthly Packages",
                "Want to minimize DevOps costs and make sure your Cloud infrastructure at the hand of our experts?",
                monthlyServiceItems
            )}
        </div>
    )
}

const servicesSection = (sectionId, title, description, serviceItems) => {
    return (
        <div className="grid" id={sectionId}>
            <div className="col-12 headline margin-top-3em">{title}</div>
            <p className="body" style={{ textAlign: 'center', margin: '0 auto', maxWidth: '800px' }}>
                {description}
            </p>
            <div className="col-12_md-12"></div>
            {serviceItems}
        </div>
    );
};

const ServiceItem = ({ id, image, title, description, points, price }) => {
    const pointStyle = {
        margin: '5px 0', // Adjust as needed for your design
        // paddingLeft: '20px', // Adjust as needed for your design
        textAlign: 'center' // Ensures that all text is aligned uniformly
    };
    const formattedPrice = price && price.toLocaleString();

    return (
        <div className="col-3_md-12 feature unify" key={id}>
            <div className="image"><img alt={title} src={image} /></div>
            <div className="headline">{title}</div>
            <div className="body">{description}</div>
            {points && points.map((point, index) => (
                <p className="body" key={`${id}-${index}`} style={pointStyle}>{". " + point}</p>
            ))}
            {price && <a href="/contact">{`Price: $${formattedPrice}`}</a>}
        </div>
    )
}


export default Services;